/**
 * Created by slava on 20/3/20
 */

const MovesLog = function (game, options) {
    cleverapps.EventEmitter.call(this);

    this.tilegame = game;

    this.undoBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_UNDO);

    this.log = [];

    if (options) {
        this.log = options.log;
    }

    if (this.tilegame.pagination) {
        this.tilegame.pagination.on("changePage", this.clear.bind(this));
    }
};

MovesLog.prototype = Object.create(cleverapps.EventEmitter.prototype);
MovesLog.prototype.constructor = MovesLog;

MovesLog.MOVE_PLAY_CARD = 0;

MovesLog.prototype.getInfo = function () {
    return {
        log: this.log.slice()
    };
};

MovesLog.prototype.isEmpty = function () {
    return this.log.length === 0;
};

MovesLog.prototype.clear = function () {
    this.log = [];
    this.trigger("change");
};

MovesLog.prototype.showAlert = function () {
    if (!this.isEmpty()) {
        this.trigger("showAlert");
    }
};

MovesLog.prototype.push = function (type, options) {
    this.log.push({
        type,
        options
    });

    this.trigger("change");
};

MovesLog.prototype.isUndoNeedOnPreviousMove = function () {
    return this.getLastMove();
};

MovesLog.prototype.getLastMove = function () {
    return this.log[this.log.length - 1];
};

MovesLog.prototype.undoPlayCard = function (move) {
    const playCard = this.tilegame.open.pop(move);
    this.tilegame.undoCard(playCard);
};

MovesLog.prototype.executeUndo = function () {
    const move = this.log.pop();

    this.undoPlayCard(move);

    this.trigger("change");
};